// 抓取日志 — 真实后端 API（/api/scrape/logs）
import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'

export interface CrawlLogItem {
  id: number
  scraperName: string
  startedAt: number
  finishedAt: number | null
  status: 'success' | 'failed' | 'partial' | 'running' | 'expired'
  errorMsg: string | null
  recordsCount: number | null
  triggerType: 'schedule' | 'manual' | 'backfill' | 'webhook'
  durationSeconds: number | null
}

export interface ScraperStat {
  name: string
  runs: number
  success: number
  failed: number
  rows: number
}

export interface CrawlLogStats {
  totalRuns: number
  successRuns: number
  failedRuns: number
  successRate: number
  totalRecords: number
  byScraper: ScraperStat[]
}

export interface CrawlLogListResponse {
  items: CrawlLogItem[]
  total: number
  page: number
  pageSize: number
  stats: CrawlLogStats
}

interface CrawlLogParams {
  days?: number
  page?: number
  page_size?: number
  status?: string
  trigger_type?: string
  scraper_name?: string
  search?: string
}

export function useCrawlLogs(params: CrawlLogParams = {}) {
  return useQuery({
    queryKey: ['scrape', 'logs', params],
    queryFn: () => {
      const qp = new URLSearchParams()
      if (params.days) qp.set('days', String(params.days))
      if (params.page) qp.set('page', String(params.page))
      if (params.page_size) qp.set('page_size', String(params.page_size))
      if (params.status) qp.set('status', params.status)
      if (params.trigger_type) qp.set('trigger_type', params.trigger_type)
      if (params.scraper_name) qp.set('scraper_name', params.scraper_name)
      if (params.search) qp.set('search', params.search)
      return get<CrawlLogListResponse>(`/scrape/logs?${qp.toString()}`)
    },
    refetchInterval: 30_000,
  })
}
